import React, { Component } from 'react';
import {get} from 'lodash';

export default class LoadingDataTale extends Component {

  renderLoading () {
    const tableLoading = [];
    const {countLoading} = this.props;
    for (let i = 0; i < countLoading; i++) {
      tableLoading.push(
      <div key={i} className="loading-content">
        <span className="shape1"></span>
        <span className="shape2"></span>
        <span className="shape3"></span>
        <span className="shape4"></span>
        <span className="shape5"></span>
        <span className="shape6"></span>
        <span className="shape7"></span>
        <span className="shape8"></span>
        <span className="shape9"></span>
        <span className="shape10"></span>
        <span className="shape11"></span>
        <span className="shape12"></span>
        <span className="shape13"></span>
      </div>);
    }
    return tableLoading;
  }

  render() {
    return (
      <td colSpan={this.props.colSpan}>
        { this.renderLoading() }
      </td>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/datatable/LoadingDataTale.jsx